import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Taxes = 'Taxes',
}

export const queryKeys = {
  taxes: (clientId: string, stepId?: string) => [
    QueryFeature.Profile,
    QueryKey.Taxes,
    clientId,
    stepId,
  ],
};
